<script setup lang="ts">
import { computed, ref } from 'vue'
import AlertComponent from '@/components/AlertComponent.vue';

interface Props {
  amenities: string[]
}

const props = defineProps<Props>()
const showingAll = ref(false);

const reducedAmenities = computed(() => {
  return props.amenities.slice(0, 20)
})
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-lg font-medium leading-6 text-gray-900">Amenidades generales</span>
    <div class="flex flex-wrap gap-2">
      <span v-for="amenity in reducedAmenities" :key="amenity" class="px-2 py-1 bg-gray-100 rounded-full text-sm text-gray-700 fade-transition hover:bg-gray-200 hover:cursor-default">{{amenity}}</span>

      <button v-if="reducedAmenities.length < props.amenities.length" class="px-2 py-1 bg-gray-800 rounded-full text-sm text-gray-50 fade-transition hover:bg-gray-900" @click="showingAll = true">Ver más</button>
    </div>
  </div>

  <AlertComponent v-model="showingAll" :dismiss="true" type="info">
    <template #title>
      <span class="text-lg font-medium leading-6 text-gray-900">Todas las amenidades generales</span>
    </template>

    <template #body>
      <div class="flex flex-col gap-1 max-h-72 overflow-y-auto">
        <div class="flex flex-wrap gap-2 gap-y-3">
          <span v-for="amenity in amenities" :key="amenity" class="px-2 py-1 bg-gray-100 rounded-full text-sm text-gray-700 fade-transition hover:bg-gray-200 hover:cursor-default">{{amenity}}</span>
        </div>
      </div>
    </template>
  </AlertComponent>
</template>



<style scoped>

</style>